import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faqData } from '../../data/mock';
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  return (
    <section id="faq" className="py-20 md:py-32 bg-slate-900 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent" />
        <div className="absolute top-1/2 right-0 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-800 rounded-2xl mb-6">
            <HelpCircle className="w-8 h-8 text-emerald-400" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Get answers to the most common questions about the funding process. No question is too simple — we're here to create clarity.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqData.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`faq-${index}`}
              className="bg-slate-950/50 backdrop-blur-sm border border-slate-800 rounded-xl overflow-hidden data-[state=open]:border-emerald-500/30 transition-all"
            >
              <AccordionTrigger className="px-6 py-5 hover:no-underline hover:bg-slate-800/30 transition-colors text-left">
                <span className="text-white font-medium pr-4">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-6">
                <div className="pt-2 text-slate-400 leading-relaxed">
                  {faq.answer}
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional Help */}
        <div className="mt-12 text-center">
          <p className="text-slate-400">
            Still have questions?{' '}
            <button 
              onClick={() => document.getElementById('chatbot-trigger')?.click()}
              className="text-emerald-400 hover:text-amber-300 font-medium transition-colors"
            >
              Ask the Funding Guide
            </button>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
